import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import Link from 'components/common/Link/Link'
import InfinityScroll from 'components/common/InfinityScroll'
import SpinnerIcon from 'components/common/SpinnerIcon/SpinnerIcon'
import { H2 } from 'components/common/Text/Text'
import ResultsPageListHeader from './ResultsPageListHeader'
import { arrayHasValues } from 'helpers/utils'

const SortableResultList = ({
  displayGlobalSearch,
  infinityScrollHandler,
  sortOptions,
  totalNumRecs,
  viewAllLink,
  title,
  tiles,
  TileComponent,
  showSpinner,
  ...props
}) =>
  <Block data-at-globalsearch-resultrow>
    {
      displayGlobalSearch ?
        <Header>
          <Title data-at-globalsearch-resultrow-title noMargin>{ title }</Title>
          {
            arrayHasValues(tiles) && totalNumRecs > 1 &&
            <View data-at-globalsearch-resultrow-viewall to={ viewAllLink } bolder>View All</View>
          }
        </Header> :
        <ResultsPageListHeader totalNumRecs={ totalNumRecs } sortOptions={ sortOptions } />
    }
    {
      tiles.map(({ itemKey, ...data }, index) =>
        <Row key={ `${itemKey}-${index}` } data-at-globalsearch-result>
          <TileComponent { ...props } { ...data } />
        </Row>
      )
    }
    {
      (!!infinityScrollHandler && !displayGlobalSearch) &&
        <InfinityScroll scrollPadding={ 800 } handler={ infinityScrollHandler }>
          {
            showSpinner &&
            <SpinnerWrapper>
              <InfinitySpinnerIcon />
            </SpinnerWrapper>
          }
        </InfinityScroll>
    }
  </Block>

SortableResultList.propTypes = {
  displayGlobalSearch: PropTypes.bool,
  infinityScrollHandler: PropTypes.func,
  showSpinner: PropTypes.bool,
  sortOptions: PropTypes.arrayOf(PropTypes.shape()),
  TileComponent: PropTypes.func,
  tiles: PropTypes.arrayOf(PropTypes.shape()),
  title: PropTypes.string,
  totalNumRecs: PropTypes.number,
  viewAllLink: PropTypes.string
}

export default SortableResultList

const Block = styled.div`
  padding-bottom: 10px;
  ${Media.desktop`
    padding-bottom: 30px;

    & + & {
      padding-top: 54px;
    }
  `}

  & + & {
    padding-top: 10px;
    border-top: 1px solid ${Theme.colors.light_grey};
  }
`

const Header = styled.div`
  margin-bottom: 20px;
  ${Mixin.clearFix()}
`

const Title = styled(H2)`
  float: left;
  color: ${Theme.colors.sub_grey};
  text-transform: uppercase;
  ${Mixin.font.GothamBold(26, 600)}
`

const View = styled(Link)`
  float: right;
`

const Row = styled.div`
  & + & {
    margin-top: 25px;
  }
`

const InfinitySpinnerIcon = styled(SpinnerIcon)`
  position: absolute;
  top: 30px;
  left: 50%;
`

const SpinnerWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 60px;
`
